module.exports = __webpack_public_path__ + "img/login.4dd5713a.png";